// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"context-menu_wrapper__1RbJ5","fadeIn":"context-menu_fadeIn__2iXyj","remove":"context-menu_remove__2qqPM","clear":"context-menu_clear__3Ez6y"};